import React from 'react'
import { StrikeZone } from '../../schema/types.ts'

type ZoneScaleTextProps = {
    shouldShowNormalized: boolean
    strikeZone: StrikeZone
}
export default function ZoneScaleText({
    shouldShowNormalized,
    strikeZone,
}: ZoneScaleTextProps) {
    const isActualHeight = strikeZone === 'personal' || !shouldShowNormalized
    const zoneText = isActualHeight
        ? 'Actual Pitch Height'
        : 'Pitch Location Adjusted for Batter Zone'

    // const zoneX = shouldShowNormalized ? -170 : -145
    const zoneHeight = 16

    return (
        <g transform="translate(-5, 520)">
            <g transform={`translate(${-16}, ${-zoneHeight + 1})`}>
                <rect
                    fill="#f2f2f2"
                    stroke="#666"
                    width="10"
                    height={zoneHeight}
                    strokeWidth="2"
                    strokeDasharray="4 2"
                />
            </g>
            <text className="legend" textAnchor="start" fill="#666">
                {zoneText}
            </text>
        </g>
    )
}
